import React, { useContext } from "react";
import { ContentSection, Grid, GridColumn, GridRow, LabeledDate, LabeledText } from "sprint-common-web";

import { OrderDashboardContext } from "../provider/OrderDashboardContext";

interface OrderDeliverySectionProps {
    height: number;
}

export const OrderDeliverySection: React.VFC<OrderDeliverySectionProps> = ({ height }: OrderDeliverySectionProps) => {
    const { orderDashboardItem, isLoading } = useContext(OrderDashboardContext);

    return (
        <ContentSection header="Delivery" style={{ height }} isLoading={isLoading} testId={"delivery-section"}>
            <Grid>
                <GridRow>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Endpoint"
                            testId="order-endpoint"
                            value={orderDashboardItem.deliveryEndpoint.name}
                        />
                        <LabeledDate
                            label="Due date"
                            testId="order-date"
                            value={new Date(orderDashboardItem.dueDate)}
                        />
                        <LabeledDate
                            label="Delivery date"
                            testId="order-date"
                            value={
                                orderDashboardItem.deliveryDate ? new Date(orderDashboardItem.deliveryDate) : undefined
                            }
                        />
                        <LabeledText
                            label="Integrator"
                            testId="order-integrator"
                            value={orderDashboardItem.integrator.name}
                        />
                    </GridColumn>
                    <GridColumn lg={6}>
                        <LabeledText
                            label="Target file name"
                            testId="order-targetFileName"
                            value={orderDashboardItem.targetFileName}
                            textTooltip
                        />
                        <LabeledText
                            label="Folder"
                            testId="order-deliveryFolder"
                            value={orderDashboardItem.deliveryFolder}
                            textTooltip
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
